import React from "react";
import { Row, Col } from "reactstrap";
import { useVendor } from "../Store/VendorStore";

const StarRating = () => {
  const { averageRating } = useVendor();

  // Generate stars based on average rating
  const renderStars = () => {
    const fullStars = Math.floor(averageRating); // Full stars
    const halfStar = averageRating % 1 >= 0.25 && averageRating % 1 < 0.75; // Half star if rating is between 0.25 and 0.75
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0); // Remaining empty stars

    const stars = [];

    // Add full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <i
          key={`full-${i}`}
          className="bi bi-star-fill"
          style={{ color: "#FFCE00", padding: "2px" }}
        ></i>
      );
    }

    // Add half star if needed
    if (halfStar) {
      stars.push(
        <i
          key="half"
          className="bi bi-star-half"
          style={{ color: "#FFCE00", padding: "2px" }}
        ></i>
      );
    }

    // Add empty stars
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <i
          key={`empty-${i}`}
          className="bi bi-star"
          style={{ color: "#FFCE00", padding: "2px" }}
        ></i>
      );
    }

    return stars;
  };

  return (
    <Row className="mt-2">
      <Col className="text-center">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          {renderStars()} {/* Display dynamic stars */}
          {averageRating?.toFixed(1)} {/* Display rating number */}
        </h2>
      </Col>
    </Row>
  );
};

export default StarRating;
